/** `pathName` is both the tenant's database name and its public URL slug. */
const TENANT_BASE_URL = 'https://accounting2.pakaithip.com';

export const tenantUrl = (pathName: string) => `${TENANT_BASE_URL}/${pathName}`;
export const tenantLoginUrl = (pathName: string) => `${tenantUrl(pathName)}/login`;
